export type MetabaseProps = {
    id: string;
    resourceKey: string;
    frameWidth: string
    frameHeight: string
    resourceId: number;
    chartParams?: Record<string, any>;
};

export const defaults = {
    chartParams: {params:{}}
};
